import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import t from '../../common/t';
export function colorEdit(text, start, end, color) {
  if (start === end || start < 0 || end > text.length) return null;
  const before = text.slice(0, start).match(/\[color=(?:#[0-9a-f]{3,8}|[a-z]+)\]$/i);
  if (before && /^\[\/color\]/i.test(text.slice(end))) {
    start -= before[0].length;
    end += 8;
  }
  const selected = text.slice(start, end).replace(/\[color=(?:#[0-9a-f]{3,8}|[a-z]+)\]|\[\/color\]/gi, '');
  return {
    start,
    end,
    text: color ? `[color=${color}]${selected}[/color]` : selected
  };
}
export default class ColorModal extends Modal {
  className() {
    return 'CCOT-color-modal Modal--small';
  }
  title() {
    return t('lib.post_images_color');
  }
  content() {
    const empty = this.attrs.selection[0] === this.attrs.selection[1];
    return m('.Modal-body', [m('p', t(empty ? 'lib.post_images_color_select' : 'lib.post_images_color_help')), m('.CCOT-color-palette', ['#c62828', '#ad1457', '#7b1fa2', '#1565c0', '#00796b', '#2e7d32', '#9a6500', '#616161'].map(color => m(Button, {
      type: 'button',
      className: 'Button CCOT-color-swatch',
      style: {
        '--ccot-swatch': color
      },
      'aria-label': t('lib.post_images_color_value', {
        color
      }),
      disabled: empty,
      onclick: () => this.apply(color)
    }, color))), m(Button, {
      type: 'button',
      className: 'Button',
      disabled: empty,
      onclick: () => this.apply(null)
    }, t('lib.post_images_color_default')), this.error && m('p.Alert.Alert--error', {
      role: 'alert'
    }, this.error)]);
  }
  apply(color) {
    const {
      composer,
      selection,
      text
    } = this.attrs;
    if (composer.fields.content() !== text) {
      this.error = t('lib.post_images_color_changed');
      return;
    }
    const edit = colorEdit(text, ...selection, color);
    if (!edit) return;
    composer.editor.insertBetween(edit.start, edit.end, edit.text);
    this.hide();
  }
}
flarum.reg.add('bushcraftcn-ccot', 'forum/postImages/ColorModal', ColorModal);